import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Check } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { wings } from '../mock';

const Wing = ({ code }) => {
  const { theme } = useTheme();
  const wing = wings.find((w) => w.code === code);
  if (!wing) return null;
  return (
    <div style={{ background: theme.body, color: theme.bodyText }} className="transition-colors duration-500">
      <section className="py-24 px-6 lg:px-10" style={{ background: theme.sectionAlt }}>
        <div className="max-w-5xl mx-auto">
          <Link to="/" className="inline-flex items-center gap-2 text-sm mb-8 hover:gap-3 transition-all duration-300" style={{ color: theme.brand }}>
            <ArrowLeft size={16} /> Back to Home
          </Link>
          <div className="text-xs tracking-[0.3em] mb-3" style={{ color: theme.brand }}>— {wing.code} —</div>
          <h1 className="font-serif text-4xl md:text-6xl font-semibold mb-5" style={{ color: theme.brand }}>{wing.title}</h1>
          <p className="text-xl md:text-2xl italic font-serif" style={{ color: theme.muted }}>{wing.hero}</p>
        </div>
      </section>

      <section className="py-16 px-6 lg:px-10" style={{ background: theme.body }}>
        <div className="max-w-4xl mx-auto">
          <p className="text-lg md:text-xl leading-relaxed mb-12" style={{ color: theme.bodyText }}>{wing.description}</p>
          <h3 className="font-serif text-2xl mb-6" style={{ color: theme.brand }}>Areas of Focus</h3>
          <ul className="space-y-4">
            {wing.focus.map((f) => (
              <li key={f} className="flex items-start gap-3">
                <span
                  className="mt-1 w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0"
                  style={{ background: theme.accent, color: theme.accentText }}
                >
                  <Check size={14} />
                </span>
                <span style={{ color: theme.bodyText }}>{f}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="py-20 px-6 lg:px-10" style={{ background: theme.sectionAlt }}>
        <div className="max-w-5xl mx-auto grid md:grid-cols-3 gap-6">
          {wings.filter((w) => w.code !== code).map((w) => (
            <Link
              key={w.code}
              to={w.to}
              className="rounded-2xl p-7 transition-all duration-500 hover:-translate-y-1 block"
              style={{
                background: theme.cardBg,
                border: `1px solid ${theme.cardBorder}`,
              }}
            >
              <div className="font-serif text-xl font-bold mb-2" style={{ color: theme.brand }}>{w.code}</div>
              <div className="text-sm font-serif mb-2" style={{ color: theme.cardText }}>{w.title}</div>
              <div className="text-xs" style={{ color: theme.muted }}>{w.short}</div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Wing;
